<template>
  <div>
    <el-card>
      <div class="flexRow" style="flex-wrap:wrap">
        <div class="flexRow conditions">
          <div class="keyFont">关键字：</div>
          <el-input v-model="keyWords" placeholder="水印名称" style="width:200px"></el-input>
        </div>
        <div class="flexRow conditions">
          <div class="keyFont">水印状态：</div>
          <el-select v-model="state">
            <el-option v-for="(v,i) in stateList" :key="i" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <div class="flexRow conditions">
          <el-button type="primary" style="margin-right:10px" @click="currentPage=1,gettablelist()">查询</el-button>
          <buttonPermissions :datas="'imgWatermarkpush'">
            <el-button type="primary" @click="todetail({Id:0})">添加</el-button>
          </buttonPermissions>
        </div>
      </div>
      <el-table :data="tablelist" v-loading="tableloading">
        <el-table-column prop="" label="水印" min-width="100">
          <template slot-scope="scope">
            <div class="flexRow">
              <img :src="scope.row.WatermarkImgUrlComplete" style="width:40px;height:40px" alt="">
              <div style="margin-left:5px" class="fontHidden2">
                {{scope.row.Name}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="展示时间" min-width="100">
          <template slot-scope="scope">
            <div>
              {{scope.row.StartTime}}至{{scope.row.EndTime}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ProductCount" label="适用商品"></el-table-column>
        <el-table-column prop="ActivityState" label="状态"></el-table-column>
        <el-table-column prop="AddTime" label="创建时间"></el-table-column>
        <el-table-column prop="" label="操作">
          <template slot-scope="scope">
            <div>
              <buttonPermissions :datas="'imgWatermarkedit'" style="margin-right:10px">
                <el-button type="text" @click="todetail(scope.row)">编辑</el-button>
              </buttonPermissions>
              <buttonPermissions :datas="'imgWatermarkdel'" style="margin-right:10px">
                <el-button type="text" style="color:#f56c6c" @click="del(scope.row)">删除</el-button>
              </buttonPermissions>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;text-align:right" v-if="total">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import {
  activityWatermarkwatermarkList,
  activityWatermarkwatermarkDelete
}from "@/api/goods"
export default {
  components: {
    buttonPermissions
  },
  data () {
    return {
      keyWords:'',
      state:null,
      stateList:[
        {value:null,label:'全部'},
        {value:0,label:'未开始'},
        {value:1,label:'展示中'},
        {value:2,label:'已结束'},
      ],
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pagesize:20,
      total:null
    }
  },
  created () {
    this.gettablelist()
  },
  methods: {
    todetail(row){
      this.$router.push({
        path:'/market/imgWatermark/detail',
        query:{
          Id:row.Id,

        }
      })
    },
    del(row){
      this.$confirm(`是否确认删除水印【${row.Name}】？删除后不可恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.todel(row)
      }).catch(()=>{})
    },
    async todel(row){
      try{
        this.tableloading = true
        let data = await row
        let res = await activityWatermarkwatermarkDelete({
          Id:data.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pagesize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keyWords,
          State:this.state,
          Skip:(this.currentPage-1)*this.pagesize,
          Take:this.pagesize
        }
        let res = await activityWatermarkwatermarkList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    },
  }
}
</script>

<style lang = "less" scoped>
.flexRow{
  display: flex;
  align-items: center;
}
.conditions{
  margin: 0px 10px 10px 0px;
}
.keyFont{
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  font-weight: bold;
}
.fontHidden2{
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>